import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Utilities } from '../shared/utility-services.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { AuthService } from '../shared/auth.service';
import { BackendService } from '../shared/backend.service';
import { MatDialog } from '@angular/material';
import { AlertmessageService } from '../shared/alertmessage.service';
import CONFIG from '../config';
import { NotificationService } from '../notification.service';
//import { NotificationService } from '../shared/notification.service';
//import { NotificationService } from '../notification/notification.service';


export interface SecurityQuestion {
  value: number;
  viewValue: string;
}
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent extends Utilities implements OnInit {
  result:any;
  msg : any;
  id: string;
  updatedProfile: FormGroup;
  Password: FormControl;
  profileData: any;

  passwordStrength: number = 0;
  updatingPassword: boolean = false;
  passwordConfirmed: boolean = true;
  submitted: boolean = false;
  selected_Q1: string = '';
  selected_Q2: string = '';
  securityquestions: SecurityQuestion[] = [
      {value: 1, viewValue: "What was your childhood nickname?"},
      {value: 2, viewValue: "What is the name of your favorite childhood friend?"},
      {value: 3, viewValue: "What was your dream job as a child?"},
      {value: 4, viewValue: "Where is your favorite place to travel?"},
      {value: 5, viewValue: "What primary school did you attend?"},
      {value: 6, viewValue: "In what village was your first full time job?"},
      {value: 7, viewValue: "Where did you meet your spouse/partner?"},
      {value: 8, viewValue: "What is the middle name of your oldest child?"},
      {value: 9, viewValue: "What are the last four digits of your driver's licence number?"},
      {value: 10, viewValue: "What is the name of your favorite childhood friend?"},
      {value: 11, viewValue: "What is your maternal grandmother's maiden name?"}
  ];
  resetQuestions: Object[] = [];
  passwordstatus: boolean = false;
  constructor(
      public _formBuilder: FormBuilder,
      public _router: Router,
      public location: Location,
      public notificationService: NotificationService,
      public authService: AuthService,
      public backendService: BackendService,
      public dialog: MatDialog,
      public alert:AlertmessageService
  ) {
      super(location, notificationService, authService, backendService);
      this.setForm();
     
  }
  
  ngOnInit() {     
   //   console.log(this.securityquestions.length)  ;
   this.getMyProfile();
   //this.getPasswordResetQuestions();
  }
  checkpassword(){      
      let ModifyPassword = this.updatedProfile.controls['ModifyPassword'].value; 
      let ConfirmPassword =  this.updatedProfile.controls['ConfirmPassword'].value;       
      if(ModifyPassword == ConfirmPassword){           
          this.passwordstatus = false;
      }
      else{           
          this.passwordstatus = true;}
  }
  
  // updateProfiledata2(updatedProfile) {
  //     const myThis = this;
  //     this.openDialog(updatedProfile);
  // }
  

  // openDialog(updatedProfile: any): void {
  //     //localStorage.setItem('key', key);
  //     let dialogRef = this.dialog.open(ConfirmModifyComponent, {
  //         width: '50%',
  //         height: '30%',
  //         data: {  updatedProfile }
  //     });
  //     this._router.navigate(['/dashboard']);
  //     dialogRef.afterClosed().subscribe(result => {
  //         //this.GetExchangeData();
  //         //this.serviceInit();
  //     });
  // }


  updateProfiledata(updatedProfile) {
     // console.log(updatedProfile , this.passwordConfirmed);
      this.submitted = true;
      updatedProfile.logintype = this.authService.LoginType;
      //console.log(this.updatedProfile.valid , this.passwordConfirmed);
      if (this.updatedProfile.valid && this.passwordConfirmed) {
          this.backendService.putData(updatedProfile, `${CONFIG.changePasswordApiUrlBase}/${this.authService.TaskNumber}`)
              .subscribe(
              response => {
                  

                  this.submitted = false;
                  if(!response['result'])
                  {
                     // console.log("test alert");
                      this.notificationService.showNotification({ message: response['msg'], type: 'warning' });
                      this._router.navigate(['/dashboard/changePassword']);
                  }
                  else
                  {
                     this.updateProfiledata2(updatedProfile);
                  //     this.openDialog(updatedProfile);
                  //     this.notificationService.showNotification({ message: response['msg'], type: 'success' });
                  // this.authService.logout();
                  }  
              },
              error => {
                  this.serverErrorOrTimeout(error);
              });
      } else {
          //validators handle this case
         // console.log('error with form');
          this.notificationService.showNotification({ message: "New password and Confirm password does not match.", type: 'warning' });
      }
  }
  updateProfiledata2(updatedProfile)
  {
    this.backendService.postData(updatedProfile, `${CONFIG.changePasswordApiUrlBase}/${this.authService.TaskNumber}`)
    .subscribe(
    response => {
       if(response['result'])
       {
        this.submitted = false;
        this.notificationService.showNotification({ message: response['msg'], type: 'success' });
        this.authService.logout();
      }
    },error => {
        this.serverErrorOrTimeout(error);
    });
  
  
  }

  getMyProfile() {
     
      this.backendService.getData(`${CONFIG.changePasswordApiUrlBase}/${this.authService.TaskNumber}/${this.authService.LoginType}`)
          .subscribe(profileData => {

            //  console.log("getMyProfile method",profileData);              
              if(!profileData) {
                  this.notificationService.showNotification({ timer: 5000, message: profileData['msg'], type: 'error', closeable: false });
              }         
                  for(let i = 0; i < this.resetQuestions.length; i += 1) {
                      if(this.resetQuestions[i]['viewValue'] === profileData['user'].pwdResetQuestion1) {
                          this.selected_Q1 = this.resetQuestions[i].toString();
                      } else if(this.resetQuestions[i]['viewValue'] === profileData['user'].pwdResetQuestion2) {
                          this.selected_Q2 = this.resetQuestions[i].toString();
                      }
                  }

             this.updatedProfile.controls['PwdResetQuestion1'].setValue(profileData['user'].pwdResetQuestion1);
             this.updatedProfile.controls['PwdResetQuestion2'].setValue(profileData['user'].pwdResetQuestion2);
             this.updatedProfile.controls['PwdResetAnswer2'].setValue(profileData['user'].pwdResetAnswer2);
             this.updatedProfile.controls['PwdResetAnswer1'].setValue(profileData['user'].pwdResetAnswer1);              
                             
              this.updatedProfile.controls['ModifyPassword'].valueChanges
                  .debounceTime(200)
                  .subscribe((value) => {
                      this.passwordConfirmed = value === '';
                      this.updatingPassword = value !== '';
                  });

              this.updatedProfile.controls['ConfirmPassword'].valueChanges
                  .subscribe((value) => {
                      this.passwordConfirmed = this.updatedProfile.controls['ModifyPassword'].value === value;
                  });
           },
          error => {
              this.serverErrorOrTimeout(error);
          });

          }

  setSecurityQuestions(newInfo) {
      this.submitted = true;

      if (this.updatedProfile.valid) {
          this.backendService.putData(newInfo, `${CONFIG.changePasswordApiUrlBase}/updateprofilesecurityquestions`)
              .subscribe(response => {
                  if (response) {
                      //finish login process
                      this.submitted = false;
                      this.authService.loggedIn = true;

                      //remove the 'partiallogin' session variable that prevented further nav on reload
                      sessionStorage.removeItem('partial_login');

                      //hide form
                      //      this._loginService.resetQuestionsSet = true;

                      this.notificationService.showNotification({ message: response['msg'], type: 'success' });
                      this._router.navigate(['/main']);
                  } else {
                      this.notificationService.showNotification({ message: response['msg'], type: 'error' });
                  }

              }, error => {
                  this.serverErrorOrTimeout(error);
              });
      } else {
          //validators should handle this branch
      }
  }

  cancel() {
      // this._loginService.resetQuestionsSet = true;
      this._router.navigate(['/dashboard']);
      // this.authService.logout();
  }

          
  setForm() {
      this.updatedProfile = this._formBuilder.group({
          'Password': ['', Validators.minLength(1)],
          'ModifyPassword': ['',Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-+.)(/]).{8,12}$')],
          'ConfirmPassword': [''],
          'PwdResetQuestion1': [''],
          'PwdResetQuestion2': [''],
          'PwdResetAnswer1': [''],
          'PwdResetAnswer2': ['']
      });
  }
}

